import React from "react";
import { Switch } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { HubContextMenu } from "../../components";

const CALENDAR_GOALS_TAB = 7;

export const SchedulerContextMenu = ({
  showLabels = false,
  onToggleLabels = () => {},
  showSuggestions = false,
  onSuggestReschedule = () => {},
  ...rest
}) => {
  const navigate = useNavigate();
  const MENU_ITEMS = [
    {
      id: "edit",
      label: "Edit Target",
      icon: "Edit",
    },
    {
      id: "suggest",
      label: showSuggestions ? "Clear Suggestions" : "Suggest Reschedule",
      icon:  showSuggestions ? "X" : "RefreshCw",
    },
    { divider: true },
    {
      id: "show",
      label: "Show Labels",
      icon: "Tag",
      EndComponent: () => (
        <Switch
          size="small"
          checked={showLabels}
          onChange={onToggleLabels}
          onClick={(e) => e.stopPropagation()}
          sx={{ ml: 1 }}
        />
      ),
    },
  ];

  const onSelect = (item) => {
    switch (item?.id) {
      case "suggest":
        onSuggestReschedule();
        break;
      case "edit":
        navigate(`/organization?value=${CALENDAR_GOALS_TAB}`);
        break;
      default:
        break;
    }
  };

  return (
    <HubContextMenu
      id={"scheduler-bar-chart"}
      loading={false}
      menuItems={MENU_ITEMS}
      onSelect={onSelect}
      IconButtonProps={{ sx: { margin: 0, padding: 0 } }}
      {...rest}
    />
  );
};

export default SchedulerContextMenu;
